import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import { SiteRouteQueryParams } from 'types/protein';
import { MapViewContainer } from './SiteMapWidget.elements';
import MapCard from '../../../components/SiteMap';

export const SiteMapWidget = (): JSX.Element => {
  const { plantId } = useParams<SiteRouteQueryParams>();
  return (
    <MapViewContainer>
      <MapCard plantId={plantId} />
    </MapViewContainer>
  );
};

export default SiteMapWidget;
